module.exports = __webpack_public_path__ + "img/AT0000047784135.868f152b.png";